import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { BaseComponent } from "@m4u-angular/base/component/BaseComponent";
import { ServiceBagService, ServiceBagServices } from "@m4u-angular/base/component/ServiceBag";
import { BaseState } from "@m4u-angular/base/entities/BaseEntities";


@Component({
    providers: ServiceBagServices,
    selector: 'm4u-switch-button',
    templateUrl: './switch-button.component.html',
    styleUrls: ['./switch-button.component.scss']
})
export class SwitchButton extends BaseComponent<BaseState> {
    constructor(A: ServiceBagService) {
        super(A, "SwitchButton", BaseState);
    }

    @ViewChild('slider') slider: ElementRef;
    @ViewChildren('input') inputs: QueryList<ElementRef>;

    @Input() Value: string | number;
    @Output() ValueChange = new EventEmitter<string | number>();
    @Input() ValueExpr: string = 'Value';
    @Input() DisplayExpr: string = 'Text';

    _items = [];
    @Input()
    set Items(v) {
        // if (v.length !== 2) {
        //     throw new Error('Items has to contain exactly 2 elements');
        // }
        this._items = v;
    };
    get Items() {
        return this._items;
    }

    Id(value: string) {
        return 'm4u-switch-button-' + value;
    }

    override OnInitComponentFinished() {
        setTimeout(() => {
            const input = this.inputs.find(item => item.nativeElement.checked);
            this.MoveSlider(input.nativeElement);
        }, 200);
    }

    OnChange({ target }) {
        this.ValueChange.emit(target.value);
        this.MoveSlider(target);
    }

    MoveSlider(target: HTMLInputElement) {
        if (!target) return;

        const label = target.labels[0];
        if (!label) return;
        this.slider.nativeElement.style.width = label.clientWidth + 'px';

        let shift = this.A.Screen.IsRTL() ? label.clientWidth + label.offsetLeft - label.offsetParent.clientWidth : label.offsetLeft;
        this.slider.nativeElement.style.transform = `translateX(${shift}px)`;
    }
}